import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import DevContentContainer from './DevContentContainer'
import './DevDashboard.scss'

export default class DevDashboard extends Component {
    render() {
        return (
            <div className='dev-dashboard'>
                <Sidebar />
                <DevContentContainer />
            </div>
        )
    }
}

const Sidebar = () => {
    const menuItems = [
        {
            title: 'Teachers',
            to: '/backdoor/teachers'
        },
        {
            title: 'Students',
            to: '/backdoor/students'
        },
        {
            title: 'Listings',
            to: '/backdoor/listings'
        },
    ]

    return (
        <div className="dev-dashboard__sidebar">
            <div className="dev-dashboard__sidebar__logocontainer">
                <img src={`${process.env.PUBLIC_URL}/512x512.png`} alt='logo' /> iCurious
            </div>
            <ul className='dev-dashboard__sidebar__menu'>
                {
                    menuItems.map((item, idx) => {
                        return (
                            <li key={idx}>
                                <Link className='dev-dashboard__sidebar__menu__item' to={item.to}>
                                    {item.title}
                                </Link>
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
}
